import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 :root{
    --primary-color: #6caeff;
    --text-color:#9CB0CA;
    --bg-color:#F7F7F7;
    --title-color:#27548C;
    --yellow-color:#FFE60A;
    --border-color:#d1d1cf;
    --border-dashed:#E9EBF8;
    --white-bg:#FFFFFF;
    --border-slider:#D9DBDE;
    --slider-bg:#F3F3F4;

  }
  html{
    font-size: 10px;
    font-family: Iran-Yekan;
  }
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    direction: rtl;
    font-family: Iran-Yekan;
  }
  ul , li {
    list-style: none;
  }
  a{
    text-decoration: none;
  }
  .container{
    padding: 0 24rem;
  }

`;

export default GlobalStyle;
